(function (root, factory) {
  var api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  if (typeof window !== 'undefined') {
    root.HutPageTransition = api;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', api.init);
    } else {
      api.init();
    }
  }
})(typeof window !== 'undefined' ? window : this, function () {
  var STORAGE_KEY = 'hut-page-transition';
  var DURATION_MS = 600;

  /* Arrow = the side the new page enters from. Old page exits the opposite
     way. Values are fractions of the full viewport, not a content box. */
  var UNITS = {
    left: { x: 1, y: 0 },
    right: { x: -1, y: 0 },
    down: { x: 0, y: -1 },
    up: { x: 0, y: 1 },
    'up-right': { x: -1, y: 1 },
    'down-left': { x: 1, y: -1 },
    'down-right': { x: -1, y: -1 },
    'up-left': { x: 1, y: 1 }
  };

  var PATH_DIRS = {
    '/pages/about': 'left',
    '/pages/service': 'right',
    '/pages/company': 'up-right',
    '/pages/contact': 'down',
    '/pages/project': 'down-right',
    '/pages/project-fanclub': 'right',
    '/pages/project-ec': 'right',
    '/pages/project-system': 'right'
  };

  /* Going back to TOP plays each page's outbound slide in reverse: the page
     exits back the way it came in and TOP re-enters from the side it left. */
  var INVERSE_DIRS = {
    left: 'right',
    right: 'left',
    down: 'up',
    'up-right': 'down-left',
    'down-right': 'up-left'
  };

  var PAGE_KEYS = {
    about: 'left',
    service: 'right',
    company: 'up-right',
    contact: 'down',
    project: 'down-right',
    'project-fanclub': 'right',
    'project-ec': 'right',
    'project-system': 'right'
  };

  var navigating = false;
  var enterPlayed = false;
  var usedViewTransition = false;
  var pendingVt = null;
  var clickBound = false;

  function unitToCss(unit) {
    return {
      x: (unit.x * 100).toFixed(2) + '%',
      y: (unit.y * 100).toFixed(2) + '%'
    };
  }

  var DIRECTIONS = {
    left: unitToCss(UNITS.left),
    right: unitToCss(UNITS.right),
    down: unitToCss(UNITS.down),
    up: unitToCss(UNITS.up),
    'up-right': unitToCss(UNITS['up-right']),
    'down-left': unitToCss(UNITS['down-left']),
    'down-right': unitToCss(UNITS['down-right']),
    'up-left': unitToCss(UNITS['up-left'])
  };

  function enterFor(dir) {
    var unit = UNITS[dir] || UNITS.left;
    return unitToCss({ x: -unit.x, y: -unit.y });
  }

  var ENTER = {
    left: enterFor('left'),
    right: enterFor('right'),
    down: enterFor('down'),
    up: enterFor('up'),
    'up-right': enterFor('up-right'),
    'down-left': enterFor('down-left'),
    'down-right': enterFor('down-right'),
    'up-left': enterFor('up-left')
  };

  function normalizePath(pathname) {
    if (!pathname) return '/';
    var path = pathname.split('?')[0].split('#')[0];
    if (path.length > 1 && path.charAt(path.length - 1) === '/') {
      path = path.slice(0, -1);
    }
    return path || '/';
  }

  /* Canonical page key for both the live site (/pages/about) and the static
     preview (about.html): 'top', one of the four page names, or null. */
  function pageKey(pathname) {
    var path = normalizePath(pathname);
    if (PATH_DIRS[path]) return path.split('/').pop();
    var seg = path.split('/').pop().replace(/\.html$/, '');
    if (path === '/' || seg === '' || seg === 'index') return 'top';
    if (PAGE_KEYS[seg]) return seg;
    return null;
  }

  function directionForPath(pathname) {
    var key = pageKey(pathname);
    return (key && PAGE_KEYS[key]) || null;
  }

  /* Direction for a link that returns to TOP (e.g. the header Hut logo):
     the inverse of the current page's own outbound direction. */
  function returnDirection() {
    var here = typeof window !== 'undefined' && window.location ? window.location.pathname : '';
    var key = pageKey(here);
    if (key && PAGE_KEYS[key]) return INVERSE_DIRS[PAGE_KEYS[key]] || null;
    return null;
  }

  function directionForAnchor(anchor) {
    var attr = anchor && anchor.getAttribute ? anchor.getAttribute('data-hut-dir') : '';
    if (attr && UNITS[attr]) return attr;
    if (pageKey(anchor && anchor.pathname) === 'top') return returnDirection();
    return directionForPath(anchor && anchor.pathname);
  }

  function prefersReducedMotion() {
    return typeof window !== 'undefined'
      && window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function supportsMpaViewTransition() {
    return typeof window !== 'undefined' && typeof window.onpageswap !== 'undefined';
  }

  function shouldIntercept(event, anchor, currentPath) {
    if (!event || !anchor) return false;
    if (event.defaultPrevented) return false;
    if (typeof event.button === 'number' && event.button !== 0) return false;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
    if (anchor.target && anchor.target !== '_self') return false;
    if (anchor.hasAttribute('download')) return false;
    if (anchor.getAttribute('rel') && /\bexternal\b/i.test(anchor.getAttribute('rel'))) return false;

    var destPath = normalizePath(anchor.pathname || '');
    if (!directionForAnchor(anchor)) return false;
    if (destPath === normalizePath(currentPath)) return false;
    if (anchor.origin && typeof window !== 'undefined' && window.location && anchor.origin !== window.location.origin) {
      return false;
    }
    return true;
  }

  function readStore() {
    try {
      return sessionStorage.getItem(STORAGE_KEY);
    } catch (error) {
      return null;
    }
  }

  function writeStore(value) {
    try {
      if (value) sessionStorage.setItem(STORAGE_KEY, value);
      else sessionStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      /* ignore quota / private mode */
    }
  }

  function resetVisualState() {
    var html = document.documentElement;
    html.classList.remove(
      'hut-is-leaving',
      'hut-is-entering',
      'hut-enter-ready',
      'hut-dir-left',
      'hut-dir-right',
      'hut-dir-down',
      'hut-dir-up',
      'hut-dir-up-right',
      'hut-dir-down-left',
      'hut-dir-down-right',
      'hut-dir-up-left',
      'hut-reduce-motion'
    );
    html.style.removeProperty('--hut-leave-x');
    html.style.removeProperty('--hut-leave-y');
    html.style.removeProperty('--hut-enter-x');
    html.style.removeProperty('--hut-enter-y');
    html.style.removeProperty('--hut-scroll-lock');
    delete html.dataset.hutUsedVt;
    delete html.dataset.hutEnterDir;
    navigating = false;
    pendingVt = null;
  }

  function applyDirection(dir) {
    var leave = DIRECTIONS[dir] || DIRECTIONS.left;
    var enter = ENTER[dir] || ENTER.left;
    var html = document.documentElement;
    html.classList.remove('hut-dir-left', 'hut-dir-right', 'hut-dir-down', 'hut-dir-up', 'hut-dir-up-right', 'hut-dir-down-left', 'hut-dir-down-right', 'hut-dir-up-left');
    html.classList.add('hut-dir-' + dir);
    html.style.setProperty('--hut-leave-x', leave.x);
    html.style.setProperty('--hut-leave-y', leave.y);
    html.style.setProperty('--hut-enter-x', enter.x);
    html.style.setProperty('--hut-enter-y', enter.y);
    if (prefersReducedMotion()) {
      html.classList.add('hut-reduce-motion');
    }
  }

  function lockLeaveViewport() {
    var y = window.scrollY || 0;
    document.documentElement.style.setProperty('--hut-scroll-lock', '-' + y + 'px');
  }

  function addVtType(viewTransition, dir) {
    if (!viewTransition || !viewTransition.types || !dir) return;
    viewTransition.types.add('hut-slide');
    viewTransition.types.add('hut-' + dir);
  }

  function watchVt(viewTransition) {
    pendingVt = viewTransition || null;
    if (!viewTransition || !viewTransition.finished || !viewTransition.finished.finally) {
      return;
    }
    viewTransition.finished.finally(function () {
      if (pendingVt === viewTransition) pendingVt = null;
      resetVisualState();
      writeStore('');
    });
  }

  function goTo(href) {
    window.location.assign(href);
  }

  function leaveTo(anchor, dir) {
    if (navigating) return false;
    navigating = true;
    writeStore(dir);

    if (prefersReducedMotion()) {
      goTo(anchor.href);
      return true;
    }

    applyDirection(dir);

    if (supportsMpaViewTransition()) {
      /* Immediate assign only. Prefetching the same Document here used to
         start a second network load that then swapped in after the slide. */
      goTo(anchor.href);
      return true;
    }

    lockLeaveViewport();
    document.documentElement.classList.add('hut-is-leaving');
    window.setTimeout(function () {
      goTo(anchor.href);
    }, DURATION_MS);
    return true;
  }

  function adoptRevealState() {
    var reveal = typeof window !== 'undefined' ? window.__hutPageReveal : null;
    if (reveal && reveal.hasVt) {
      usedViewTransition = true;
      if (typeof document !== 'undefined') {
        document.documentElement.dataset.hutUsedVt = '1';
      }
    }
    if (typeof document !== 'undefined' && document.documentElement.dataset.hutUsedVt === '1') {
      usedViewTransition = true;
    }
    if (typeof document !== 'undefined' && document.activeViewTransition) {
      usedViewTransition = true;
      watchVt(document.activeViewTransition);
    }
  }

  function shouldPlayCssEnter(options) {
    options = options || {};
    if (options.prefersReducedMotion) return false;
    if (!options.dir || !UNITS[options.dir]) return false;
    if (options.usedViewTransition) return false;
    if (options.activeViewTransition) return false;
    return true;
  }

  function playEnter() {
    if (enterPlayed) return;
    adoptRevealState();

    var dir = readStore();
    if (!shouldPlayCssEnter({
      dir: dir,
      prefersReducedMotion: prefersReducedMotion(),
      usedViewTransition: usedViewTransition,
      activeViewTransition: typeof document !== 'undefined' && Boolean(document.activeViewTransition)
    })) {
      if (usedViewTransition) {
        enterPlayed = true;
        return;
      }
      enterPlayed = true;
      writeStore('');
      resetVisualState();
      return;
    }

    enterPlayed = true;
    writeStore('');
    applyDirection(dir);
    document.documentElement.classList.add('hut-is-entering');
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        document.documentElement.classList.add('hut-enter-ready');
        window.setTimeout(resetVisualState, DURATION_MS + 40);
      });
    });
  }

  function onDocumentClick(event) {
    if (navigating) {
      event.preventDefault();
      if (event.stopPropagation) event.stopPropagation();
      return;
    }
    if (window.Shopify && window.Shopify.designMode) return;

    var anchor = event.target.closest && event.target.closest('a[href]');
    if (!anchor) return;
    if (!shouldIntercept(event, anchor, window.location.pathname)) return;

    event.preventDefault();
    if (event.stopPropagation) event.stopPropagation();
    leaveTo(anchor, directionForAnchor(anchor));
  }

  function init() {
    if (typeof document === 'undefined' || document.documentElement.dataset.hutTransitionReady === 'true') {
      return;
    }
    document.documentElement.dataset.hutTransitionReady = 'true';

    if (!clickBound) {
      clickBound = true;
      document.addEventListener('click', onDocumentClick, true);
    }

    window.addEventListener('pageswap', function (event) {
      if (!event.viewTransition) return;
      if (prefersReducedMotion()) {
        event.viewTransition.skipTransition();
        resetVisualState();
        return;
      }
      var dir = readStore();
      if (!dir || !UNITS[dir]) {
        event.viewTransition.skipTransition();
        return;
      }
      applyDirection(dir);
      addVtType(event.viewTransition, dir);
      watchVt(event.viewTransition);
    });

    window.addEventListener('pagereveal', function (event) {
      var dir = readStore();
      if (event.viewTransition) {
        usedViewTransition = true;
        document.documentElement.dataset.hutUsedVt = '1';
        window.__hutPageReveal = { hasVt: true, dir: dir };
        if (!dir || !UNITS[dir] || prefersReducedMotion()) {
          event.viewTransition.skipTransition();
          resetVisualState();
          writeStore('');
        } else {
          applyDirection(dir);
          addVtType(event.viewTransition, dir);
          watchVt(event.viewTransition);
        }
      } else {
        window.__hutPageReveal = window.__hutPageReveal || { hasVt: false, dir: dir };
      }
      playEnter();
    });

    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        enterPlayed = false;
        navigating = false;
        usedViewTransition = false;
        if (pendingVt && pendingVt.skipTransition) {
          try { pendingVt.skipTransition(); } catch (error) {}
        }
        resetVisualState();
        writeStore('');
        return;
      }
      playEnter();
    });

    window.addEventListener('pagehide', function () {
      if (!navigating && !pendingVt) resetVisualState();
    });

    if (document.readyState === 'complete') {
      playEnter();
    }
  }

  return {
    DURATION_MS: DURATION_MS,
    UNITS: UNITS,
    DIRECTIONS: DIRECTIONS,
    ENTER: ENTER,
    PREFETCH_ENABLED: false,
    shouldPlayCssEnter: shouldPlayCssEnter,
    normalizePath: normalizePath,
    directionForPath: directionForPath,
    directionForAnchor: directionForAnchor,
    shouldIntercept: shouldIntercept,
    init: init,
    resetVisualState: resetVisualState
  };
});
